module.exports = __webpack_public_path__ + "img/Step1.50fec32.svg";